var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-expansion-panels",
        {
          model: {
            value: _vm.panelExpanded,
            callback: function($$v) {
              _vm.panelExpanded = $$v
            },
            expression: "panelExpanded"
          }
        },
        [
          _c(
            "v-expansion-panel",
            [
              _c(
                "v-expansion-panel-header",
                [
                  _c(
                    "v-row",
                    [
                      _c("v-col", [
                        _c("span", [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t(
                                  "delegationOrder.form.additionalRestrictions.title"
                                )
                              ) + ": "
                            )
                          ]),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.customRules,
                                  expression: "!customRules"
                                }
                              ]
                            },
                            [
                              _c("b", { staticClass: "green--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.additionalRestrictions.notSet.title"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                " - " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.additionalRestrictions.notSet.description"
                                    )
                                  )
                              )
                            ]
                          ),
                          _c(
                            "span",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.customRules,
                                  expression: "customRules"
                                }
                              ]
                            },
                            [
                              _c("b", { staticClass: "red--text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.additionalRestrictions.set.title"
                                    )
                                  )
                                )
                              ]),
                              _vm._v(
                                " - " +
                                  _vm._s(
                                    _vm.$t(
                                      "delegationOrder.form.additionalRestrictions.set.description"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-expansion-panel-content",
                [
                  _c(
                    "v-row",
                    { attrs: { dense: "" } },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              items: _vm.transport_types,
                              "item-text": "name",
                              "item-value": "id",
                              label: _vm.$t(
                                "delegationOrder.form.additionalRestrictions.allowedTransportTypes.name"
                              ),
                              multiple: "",
                              clearable:
                                _vm.$store.state.DelegationOrder.readonly !==
                                true,
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true
                            },
                            model: {
                              value: _vm.contextAllowedTransportModel,
                              callback: function($$v) {
                                _vm.contextAllowedTransportModel = $$v
                              },
                              expression: "contextAllowedTransportModel"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-col",
                        { attrs: { cols: "6" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              readonly:
                                _vm.$store.state.DelegationOrder.readonly ===
                                true,
                              label: _vm.$t(
                                "delegationOrder.form.additionalRestrictions.allowedTransportValue.name"
                              )
                            },
                            model: {
                              value: _vm.contextAllowedTransportCostModel,
                              callback: function($$v) {
                                _vm.contextAllowedTransportCostModel = $$v
                              },
                              expression: "contextAllowedTransportCostModel"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }